import React, { useCallback, useMemo, useState } from 'react';
import { isNil, isEmpty } from 'lodash';
import Modal from '../../utils/Modal';
import useT from '../../utils/Translations/useT';
import AddQuickLinkForm from './AddQuickLinkForm';
import styles from '../../utils/Breadcrumbs/Breadcrumbs.scss';
import IconButton from '../../controls/IconButton';
const QuickLinkModal = ({ entity, isButtonDisplayed = true, handleModalOpen, isModalOpen }) => {
    const [isQLModalOpen, setIsQLModalOpen] = useState(false);
    const t = useT();
    const _title = useMemo(() => entity && entity.id && !isEmpty(entity.name)
        ? t('Edit Quick Link')
        : t('Add Quick Link'), [t, entity]);
    const handleQLModalOpen = useCallback(() => {
        handleModalOpen
            ? handleModalOpen()
            : setIsQLModalOpen(prevQlModalOpen => !prevQlModalOpen);
    }, [setIsQLModalOpen, handleModalOpen]);
    return (<>
      {isButtonDisplayed && (<IconButton className={styles.qlButton} dataCy="quick-link-open-button" hasBackground={false} iconName="link5" title={t('Add to Quick Links')} onClick={handleQLModalOpen}/>)}
      <Modal className={styles.modalWrap} size="sm" title={_title} visible={isNil(isModalOpen) ? isQLModalOpen : isModalOpen} onClose={handleQLModalOpen}>
        <AddQuickLinkForm entity={entity} onCancel={handleQLModalOpen}/>
      </Modal>
    </>);
};
export default QuickLinkModal;
